import { OccupancyConfigState } from '../../Occupancy/hooks/useOccupancyConfig'

export const convertOccupancyConfigToState = (config: any): OccupancyConfigState => {
    return {
        enabled: config?.enabled || false,
        lot_capacity_wl: config?.lot_capacity_wl ?? 0,
        excluded_stations: config?.excluded_stations ?? [],
        timeout: config?.timeout ?? 0,
        timeout_wl: config?.timeout_wl ?? 0,
        lpness: config?.filters?.lpness ?? 0,
        motorcycle: config?.filters?.motorcycle ?? false,
        truck: config?.filters?.truck ?? false,
        undetected_vehicles: config?.filters?.undetected_vehicle ?? false,
        version: config?.version ?? '0.2.0',
        lpr: config?.filters?.lpr ?? 0
    }
}
